type ClickContactUsButtonEventArgs = {
  threadId: string
  helpCenterSessionId: string
}

export const clickContactUsButtonEvent = (args: ClickContactUsButtonEventArgs) => {
  const extra = {
    thread_id: args.threadId,
    help_center_session_id: args.helpCenterSessionId,
  }

  return {
    event: 'support_conversation_actions.contact_vinted_support_clicked',
    extra,
  }
}
